module.exports = __webpack_public_path__ + "static/christianwork5-81ce63699dc5bcf130829ee848534bbf.jpg";